import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

function padTo2Digits(num) {
  return num.toString().padStart(2, "0");
}

function formatDate(date) {
  return [date.getFullYear(), padTo2Digits(date.getMonth() + 1), padTo2Digits(date.getDate())].join("-");
}

const initialState = {
  data: {
    hscodedata: {
      countryofimport: "US",
      hscode: "",
      date: formatDate(new Date()),
      language: "EN",
      suggest: "",
      selectedCountry: {},
    },
    submitbutton: false,
    hscodeempty: false,
    hscoderesults: [],
    libraryhscode: [],
    calculateLandedCostData: {},
  },
};

const hscodeSlice = createSlice({
  name: "hscodedata",
  initialState,
  reducers: {
    storeHSCodeData(state, action) {
      switch (action.payload.type) {
        case "country":
          state.data.hscodedata.countryofimport = action.payload.selectedvalue;
          break;

        case "hscode":
          state.data.hscodedata.hscode = action.payload;
          break;

        case "date":
          state.data.hscodedata.date = moment(action.payload.value).format("YYYY-MM-DD");
          break;

        case "language":
          state.data.hscodedata.language = action.payload.selectedvalue;
          break;
        case "selectedCountry":
          state.data.hscodedata.selectedCountry = action.payload.value;
          break;
        case "suggest":
          state.data.hscodedata.suggest = action.payload.selectedValue;
          break;
        default:
          break;
      }
    },
    captureButtonClick(state, action) {
      state.data.submitbutton = action.payload;
    },
    storeHSCodeResults(state, action) {
      state.data.hscoderesults = action.payload;
    },
    detectEmptyHSCode(state, action) {
      state.data.hscodeempty = action.payload;
    },
    storeLibraryHsCode(state, action) {
      state.data.libraryhscode = action.payload;
    },
    storeLandedCostData(state, action) {
      state.data.calculateLandedCostData = action.payload;
    },
  },
});

export const { storeHSCodeData, captureButtonClick, storeHSCodeResults, detectEmptyHSCode, storeLibraryHsCode, storeLandedCostData } = hscodeSlice.actions;

export default hscodeSlice.reducer;
